import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
export var SelectRange = function SelectRange(a) {
  var b = a.options,
      c = a.from,
      d = a.to,
      f = a.value,
      g = a.defaultValue,
      h = a.className,
      i = a.onChange,
      j = a.suffix,
      k = a.step,
      l = a.minOptionLabel,
      m = a.maxOptionLabel,
      n = _objectWithoutProperties(a, ["options", "from", "to", "value", "defaultValue", "className", "onChange", "suffix", "step", "minOptionLabel", "maxOptionLabel"]),
      o = _slicedToArray(f, 2),
      p = o[0],
      q = void 0 === p ? "" : p,
      r = o[1],
      s = void 0 === r ? "" : r,
      t = function t(a) {
    var b = a.target.name,
        e = a.target.value ? parseInt(a.target.value) : null,
        g = _slicedToArray(f, 2),
        h = g[0],
        j = g[1],
        k = "min" === b ? [e || c, j] : [h, e || d],
        l = k,
        m = _slicedToArray(l, 2),
        n = m[0],
        o = m[1];

    n || o || (k = null), "function" == typeof i && i(k, a);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "select"
  }, /*#__PURE__*/React.createElement("select", Object.assign({}, n, {
    name: "min",
    value: q,
    onChange: t
  }), /*#__PURE__*/React.createElement("option", null, l || "ANY"), b.map(function (a, b) {
    var c = a.name,
        d = a.value,
        e = a.slug;
    return /*#__PURE__*/React.createElement("option", {
      key: b,
      value: d
    }, isNaN(c) ? c : "".concat(c).concat(j));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "select--divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "select"
  }, /*#__PURE__*/React.createElement("select", Object.assign({}, n, {
    name: "max",
    value: s,
    onChange: t
  }), /*#__PURE__*/React.createElement("option", null, m || "ANY"), b.map(function (a, b) {
    var c = a.name,
        d = a.value,
        e = a.slug;
    return /*#__PURE__*/React.createElement("option", {
      key: b,
      value: d
    }, isNaN(c) ? c : "".concat(c).concat(j));
  }))));
};
export default SelectRange;